import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes with proper precedence handling
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format duration from minutes to hours (e.g., 90 -> "1.5 hrs", 60 -> "1 hr")
 */
export function formatDurationHours(minutes: number): string {
  const hours = minutes / 60
  if (hours === 1) return '1 hr'
  return `${hours} hrs`
}
